import copy from 'copy-to-clipboard';

export async function copyToClipboard(text: string) {
  return copy(text);
}
